import { render } from "./Letter.vue?vue&type=template&id=ac207a06&scoped=true"
import script from "./Letter.vue?vue&type=script&lang=ts"
export * from "./Letter.vue?vue&type=script&lang=ts"

import "./Letter.vue?vue&type=style&index=0&id=ac207a06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ac207a06"

export default script